export default {"src":"/_next/static/media/d.064fa3e8.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};